import React, { ReactNode } from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'

interface ButtonActionProps {
  text: ReactNode
  tooltip: ReactNode
  icon: IconDefinition
  onClick: () => void
}

export function ButtonAction({
  text,
  tooltip,
  icon,
  onClick,
}: ButtonActionProps) {
  return (
    <CommonToolTip text={tooltip} position="top">
      <Button
        onClick={onClick}
        className="h-100 w-100 d-flex align-items-center justify-content-center"
      >
        <FontAwesomeIcon size={'xs'} icon={icon} />
        <span className="ml-2">{text}</span>
      </Button>
    </CommonToolTip>
  )
}

export default ButtonAction
